import React, { useState, useCallback, useEffect } from 'react';
import { useNotification } from '../../../hooks/useNotification';
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import AttachFile from '@mui/icons-material/AttachFile';
import IconButton from '@mui/material/IconButton';
import ImageIcon from '@mui/icons-material/Image';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import Stack from '@mui/material/Stack';
import Box from "@mui/material/Box";
import Popover from '@mui/material/Popover';
import { Dialog } from '../../others/Dialog';
import { TemplateSelector } from '../../whatsApp/templates/TemplatesSelector';
import { TemplatePreview } from '../../whatsApp/templates/TemplatePreview';
import { parseComponents, replaceTemplateVariables, buildTemplateComponents } from '../../../utils/whatsApp/transformMessages';

const STICKERS = [
  {
    id: '1381667096210449',
    sha256: 'mJXG5itgVSsPMJbJ2slXqdv3FlDozJ/jNZyNUwzGFIs=',
    animated: true,
    mime_type: 'image/webp',
    src: '/stickers/sticker1.webp',
  },{
    id: '138166709621044',
    sha256: 'mJXG5itgVSsPMJbJ2slXqdv3FlDozJ/jNZyNUwzGFIs=',
    animated: true,
    mime_type: 'image/webp',
    src: '/stickers/sticker1.webp',
  },{
    id: '13816670962104',
    sha256: 'mJXG5itgVSsPMJbJ2slXqdv3FlDozJ/jNZyNUwzGFIs=',
    animated: true,
    mime_type: 'image/webp',
    src: '/stickers/sticker1.webp',
  },{
    id: '1381667096210',
    sha256: 'mJXG5itgVSsPMJbJ2slXqdv3FlDozJ/jNZyNUwzGFIs=',
    animated: true,
    mime_type: 'image/webp',
    src: '/stickers/sticker1.webp',
  },{
    id: '138166709621',
    sha256: 'mJXG5itgVSsPMJbJ2slXqdv3FlDozJ/jNZyNUwzGFIs=',
    animated: true,
    mime_type: 'image/webp',
    src: '/stickers/sticker1.webp',
  },{
    id: '138166709621',
    sha256: 'mJXG5itgVSsPMJbJ2slXqdv3FlDozJ/jNZyNUwzGFIs=',
    animated: true,
    mime_type: 'image/webp',
    src: '/stickers/sticker1.webp',
  },{
    id: '138166709621',
    sha256: 'mJXG5itgVSsPMJbJ2slXqdv3FlDozJ/jNZyNUwzGFIs=',
    animated: true,
    mime_type: 'image/webp',
    src: '/stickers/sticker1.webp',
  },{
    id: '13816670962',
    sha256: 'mJXG5itgVSsPMJbJ2slXqdv3FlDozJ/jNZyNUwzGFIs=',
    animated: true,
    mime_type: 'image/webp',
    src: '/stickers/sticker1.webp',
  },{
    id: '13816670962',
    sha256: 'mJXG5itgVSsPMJbJ2slXqdv3FlDozJ/jNZyNUwzGFIs=',
    animated: true,
    mime_type: 'image/webp',
    src: '/stickers/sticker1.webp',
  },{
    id: '1381667096',
    sha256: 'mJXG5itgVSsPMJbJ2slXqdv3FlDozJ/jNZyNUwzGFIs=',
    animated: true,
    mime_type: 'image/webp',
    src: '/stickers/sticker1.webp',
  },{
    id: '138166709',
    sha256: 'mJXG5itgVSsPMJbJ2slXqdv3FlDozJ/jNZyNUwzGFIs=',
    animated: true,
    mime_type: 'image/webp',
    src: '/stickers/sticker1.webp',
  },{
    id: '13816670',
    sha256: 'mJXG5itgVSsPMJbJ2slXqdv3FlDozJ/jNZyNUwzGFIs=',
    animated: true,
    mime_type: 'image/webp',
    src: '/stickers/sticker1.webp',
  },
];

const MAX_FILE_SIZE = 5 * 1024 * 1024;
const MIN_FILE_SIZE = 1 * 1024;
// Tipos MIME permitidos
const ALLOWED_MIME_TYPES = [
    // Audio
    'audio/aac', 'audio/mp4', 'audio/mpeg', 'audio/amr', 'audio/ogg', 'audio/opus',
    // Documentos
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/pdf',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/plain',
    // Imágenes
    'image/jpeg', 'image/png', 'image/webp',
    // Video
    'video/mp4', 'video/3gpp'
];
export const ChatInputBar = ({ handleSend, chatSelected, templates, messages }) => {
    const [sendNotification] = useNotification();
    const [isDragging, setIsDragging] = useState(false);
    const [text, setText] = useState('');
    const [file, setFile] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [templatesOpen, setTemplatesOpen] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const openStickers = (event) => setAnchorEl(event.currentTarget);
    const [templateVars, setTemplateVars] = useState({
        header: [],
        body: [],
        footer: []
    });
    const closeStickers = () => setAnchorEl(null);
    const isStickersOpen = Boolean(anchorEl);
    const handleSendEvent = async (customSticker=null) => {
        const mustUseTemplate = isLastMessageOlderThan24Hours(messages);
        if (mustUseTemplate && !selectedTemplate) {
            sendNotification({
                msg: 'Han pasado más de 24 horas sin actividad. Debes iniciar con un mensaje tipo plantilla.',
                variant: 'warning'
            });
            setText('');
            setFile(null);
            setAnchorEl(null);
            setTemplatesOpen(true);
            return;
        }
        if (customSticker && customSticker.src) {
            const base64 = await convertImageToBase64(customSticker.src);
            handleSend({
                type: 'sticker',
                value: base64,
                name: `${customSticker.id}.webp`,
                mimeType: customSticker.mime_type,
                animated: customSticker.animated || false,
            });
            closeStickers();
            return;
        }
        if (selectedTemplate) {
            const allVars = [
                ...templateVars.header,
                ...templateVars.body,
                ...templateVars.footer,
                ...(templateVars.buttons ?? []).flat()
            ];
            const hasVars = allVars.length > 0;
            const hasEmptyVars = allVars.some((val) => val.trim() === '');

            if (hasVars && hasEmptyVars) {
                sendNotification({
                    msg:'Por favor, completa todos los campos de la plantilla antes de enviar.',
                    variant: 'info'
            });
                return;
            }
            const components = buildTemplateComponents(templateVars, selectedTemplate);
            const {header, body, footer, buttons} = parseComponents(selectedTemplate.components || []);
            const completed_buttons = [];
            if (Array.isArray(buttons)) {
                buttons.forEach((btn, idx) => {
                    let button = {};
                    if (btn.type === 'URL' && /\{\{\d+\}\}/.test(btn.url)) {
                        const buttonVars = templateVars.buttons?.[idx];
                        const replacedUrl = buttonVars
                            ? replaceTemplateVariables(btn.url, buttonVars)
                            : '';

                        button = {
                            type: btn.type,
                            text: btn.text,
                            url: replacedUrl
                        };
                    
                    }else{
                        button = {
                            type: btn.type,
                            text: btn.text,
                            url: btn.url
                        }
                    }
                    completed_buttons.push(button)
                });
            }

            const completed_components = {
                header: header && templateVars.header
                    ? replaceTemplateVariables(header, templateVars.header)
                    : '',
                body: body && templateVars.body
                    ? replaceTemplateVariables(body, templateVars.body)
                    : '',
                footer: footer && templateVars.footer
                    ? replaceTemplateVariables(footer, templateVars.footer)
                    : '',
                buttons: completed_buttons
            };

            handleSend({
                type: 'template',
                value: {
                    language_code: selectedTemplate.language_code,
                    id_marketing_template: selectedTemplate.id_marketing_template,
                    completed_components,
                    components
                },
                name: selectedTemplate.name
            });
            setSelectedTemplate(null);
            return;
         }

        if (file) {
            const type = file.type.startsWith('image/') ? 'image'
                : file.type.startsWith('video/') ? 'video'
                : 'document';
            handleSend({ type, value: file.base64, name: file.name, mimeType: file.type });
            setFile(null);
            return;
        }

        if (text.trim()) {
            handleSend({ type: 'text', value: text });
            setText('');
            return;
        }
    };

    const onFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;
        if (!ALLOWED_MIME_TYPES.includes(selectedFile.type)) {
            sendNotification({ msg: 'Tipo de archivo no permitido.', variant: 'warning' });
            return;
        }

        if (selectedFile.size > MAX_FILE_SIZE) {
            sendNotification({ msg: 'El archivo es demasiado grande (máx 5MB)', variant: 'info' });
            return;
        }

        if (selectedFile.size < MIN_FILE_SIZE) {
            sendNotification({ msg: 'El archivo es demasiado pequeño (mínimo 1KB)', variant: 'info' });
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            const base64Data = reader.result;
            const base64Only = base64Data.split(',')[1];
            setFile({
                name: selectedFile.name,
                type: selectedFile.type,
                size: selectedFile.size,
                base64: base64Only,
            });
        };
        reader.readAsDataURL(selectedFile);
    };

    const getFileIcon = (fileType) => {
        if (fileType.startsWith('image/')) return <ImageIcon sx={{ color: '#aebac1' }} />;
        if (fileType.startsWith('video/')) return <VideoFileIcon sx={{ color: '#aebac1' }} />;
        return <InsertDriveFileIcon sx={{ color: '#aebac1' }} />;
    };

    const convertImageToBase64 = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64 = reader.result.split(',')[1]; 
                resolve(base64);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    const handleFileDrop = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if(selectedTemplate) return;
        const droppedFile = e.dataTransfer.files[0];
        if (droppedFile && ALLOWED_MIME_TYPES.includes(droppedFile.type)) {
            setFile(droppedFile);
            onFileChange && onFileChange({ target: { files: [droppedFile] } });
        } else {
            sendNotification({ msg: 'Tipo de archivo no permitido.', variant: 'warning' });
        }
        setIsDragging(false);
    }, [onFileChange]);

    const isLastMessageOlderThan24Hours = () => {
        if (!messages.length) return true;

        const lastMessage = messages[messages.length - 1];
        const lastDate = new Date(lastMessage.date);
        const now = new Date();

        const diffInMs = now - lastDate;
        const diffInHours = diffInMs / (1000 * 60 * 60);

        return diffInHours >= 24;
    };


    useEffect(() => {
        setText('');
        setFile(null);
    }, [chatSelected]);

    const handleClose = () => {
        setTemplatesOpen(false);
        setSelectedTemplate(null);
        setTemplateVars({
            header: [],
            body: [],
            footer: [],
        });
    }

    return (
        <>
            <Box
                onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
                onDragLeave={() => setIsDragging(false)}
                onDrop={handleFileDrop}
                sx={{
                    width: '100%',
                    paddingBottom: '5px',
                    paddingTop: '10px',
                    backgroundColor: '#202c33',
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: 1,
                }}
            >
                {/* Botón archivo */}
                <label htmlFor="fileInput" style={{ cursor: 'pointer', paddingBottom: '12px' }}>
                    <AttachFile
                        sx={{
                            transform: 'rotate(40deg)',
                            color: '#aebac1',
                            paddingX: 1,
                            '&:hover': { color: '#d1d7db' },
                        }}
                    />
                </label>
                <input
                    type="file"
                    id="fileInput"
                    style={{ display: 'none' }}
                    onChange={(e) => onFileChange(e)}
                />

                {/* Popover de stickers */}
                <Popover
                    open={isStickersOpen}
                    anchorEl={anchorEl}
                    onClose={closeStickers}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                >
                    <Box
                        sx={{
                            maxHeight: 300,
                            width: 300,
                            overflowY: 'auto',
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 1,
                            padding: 1,
                            backgroundColor: '#2a3942',
                        }}
                    >
                        {STICKERS.map((sticker, i) => (
                            <img
                                key={i}
                                src={sticker.src}
                                alt="sticker"
                                onClick={() => handleSendEvent(sticker)}
                                style={{ width: 60, height: 60, cursor: 'pointer' }}
                            />
                        ))}
                    </Box>
                </Popover>

                {/* Input de texto / template */}
                <Box
                    sx={{
                        flexGrow: 1,
                        backgroundColor: '#2a3942',
                        border: isDragging ? '2px dashed #aebac1' : 'none',
                        borderRadius: '15px',
                        paddingX: 1,
                        paddingY: 1,
                        maxHeight: '200px',
                        overflowY: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IconButton onClick={openStickers}>
                            <EmojiEmotionsIcon sx={{ color: '#aebac1' }} />
                        </IconButton>

                        <IconButton onClick={() => setTemplatesOpen(true)} title="Mensajes predefinidos">
                            <FeaturedPlayListIcon sx={{ color: '#aebac1' }} />
                        </IconButton>

                        {file && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    backgroundColor: '#111',
                                    padding: '4px 8px',
                                    borderRadius: '8px'
                                }}
                            >
                                {getFileIcon(file.type)}
                                <Box
                                    sx={{
                                        maxWidth: '120px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        fontSize: '13px',
                                        color: '#aebac1',
                                    }}
                                >
                                    {file.name}
                                </Box>
                                <IconButton
                                    size="small"
                                    onClick={() => { setFile(null); setText(''); }}
                                    sx={{ padding: 0.5, color: 'white' }}
                                >
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        )}

                        {(!file && !selectedTemplate) && (
                            <TextareaAutosize
                                minRows={1}
                                maxRows={6}
                                style={{
                                    width: '100%',
                                    fontSize: '15px',
                                    background: 'transparent',
                                    color: 'white',
                                    border: 'none',
                                    resize: 'none',
                                    outline: 'none',
                                    maxHeight: 120,
                                    overflowY: 'auto',
                                    lineHeight: '20px',
                                    scrollbarWidth: 'thin',
                                    scrollbarColor: 'rgb(95 95 95) #2a3942',
                                }}
                                placeholder="Escribe un mensaje"
                                value={text}
                                onChange={(e) => {
                                    if (e.target.value.length <= 3000) {
                                        setText(e.target.value);
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' && !e.shiftKey) {
                                        e.preventDefault();
                                        handleSendEvent();
                                    }
                                }}
                            />
                        )}

                        {selectedTemplate !== null && (
                            <Box
                                sx={{
                                    bottom: '100%',
                                    left: 0,
                                    width: '100%',
                                    maxHeight: '40vh',
                                    overflowY: 'auto',
                                    zIndex: 10,
                                    backgroundColor: '#111b21',
                                    borderRadius: '10px 10px 0 0',
                                    border: '1px solid #2a3942',
                                    padding: 1,
                                    boxShadow: '0px -2px 10px rgba(0,0,0,0.3)',
                                }}
                            >
                                <TemplatePreview
                                    template={selectedTemplate}
                                    isSelected={true}
                                    viewSelector={false}
                                    templateVars={templateVars}
                                    setTemplateVars={setTemplateVars}
                                />
                            </Box>
                        )}
                    </Box>
                </Box>

                {/* Botón enviar */}
                <IconButton
                    color="success"
                    onClick={handleSendEvent}
                    sx={{
                        backgroundColor: '#00a884',
                        '&:hover': { backgroundColor: '#029172' },
                        alignSelf: 'flex-end',
                        marginBottom: '7px',
                        marginRight: '10px'
                    }}
                >
                    <SendIcon sx={{ color: 'white' }} />
                </IconButton>
            </Box>
            {templatesOpen &&         
                <Dialog
                    openDialog={templatesOpen}
                    onClose={handleClose}
                    maxWidth="lg"
                    title="Selecciona una plantilla"
                    styleTitle={{ fontWeight: 'bold', color: 'white' }}
                    styleDialog={{ backgroundColor: '#111b21', color: 'white' }}
                    styleContent={{ display: 'flex', gap: 2 }}
                    content={
                        <TemplateSelector
                            templates={templates}
                            selectedTemplate={selectedTemplate}
                            setSelectedTemplate={setSelectedTemplate}
                            setTemplatesOpen={setTemplatesOpen}
                            templateVars={templateVars}
                            setTemplateVars={setTemplateVars}
                        />
                    }
                />
            }

        </>
    );

};
